import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDecimalpoints]'
})
export class DecimalpointsDirective {

  private regex: RegExp = new RegExp(/^[-+]?\d*\.?\d{0,4}$/g);
  //private regex: RegExp = new RegExp(/^[-+]?[0-9]{1,7}(\.[0-9]+)?$/g);


  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home','-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
  
    //Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) == 0 ||  this.specialKeys.indexOf(event.key) == 4) {
     return;
    }
    let current: string = this.el.nativeElement.value;
    let current_removeminus = current.split("-")[1];
    if(current_removeminus!=null){
      current =current_removeminus
    }

    const position = this.el.nativeElement.selectionStart;
    let next: string;
    if(this.specialKeys.indexOf(event.key) == 4){
      
    }else{
       next = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    }
    
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}